<template>
  <div>
    <div class="social-media">
      <template v-for="item in socialMedia" :key="item.id">
        <div
          class="wechat"
          @mouseenter="item.enter()"
          @mouseleave="item.leave()"
        >
          <img :src="item.src" :alt="item.alt" />
        </div>
      </template>
    </div>

    <!-- 使用二维码弹窗组件 -->
    <QrcodePopup :qr-info="qrCodeInfo" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import QrcodePopup from "@/components/QrcodePopup/index.vue";

const showwechat = ref(false);
const shwowechatinfo = ref(false);
const qrCodeInfo = ref([
  {
    visible: showwechat,
    title: "扫描关注医院公众号",
    imageSrc: "/Other/公众号.jpg",
    altText: "公众号",
  },
  {
    visible: shwowechatinfo,
    title: "扫描关注医院医讯号",
    imageSrc: "/Other/服务号.jpg",
    altText: "医讯号",
  },
]);
type socialMediaType = {
  id: number;
  enter: () => void;
  leave: () => void;
  src: string;
  alt: string;
};

const socialMedia = ref<socialMediaType[]>([
  {
    id: 1,
    enter: showWechat,
    leave: hideWechat,
    src: "/Other/公众号.png",
    alt: "公众号",
  },
  {
    id: 2,
    enter: showWeChatInfo,
    leave: hideWeChatInfo,
    src: "/Other/服务号.png",
    alt: "服务号",
  },
]);

function showWechat() {
  showwechat.value = true;
}

function hideWechat() {
  showwechat.value = false;
}

function showWeChatInfo() {
  shwowechatinfo.value = true;
}

function hideWeChatInfo() {
  shwowechatinfo.value = false;
}
</script>

<style scoped>
.social-media {
  display: flex;
  gap: 15px;
}

.wechat img {
  width: 30px;
  height: 30px;
  cursor: pointer;
  transition: transform 0.3s;
}

.wechat img:hover {
  transform: scale(1.1);
}

.wechatcover {
  position: fixed;
  top: 80px;
  right: 20px;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  z-index: 1001;
}

.qrcode-popup {
  text-align: center;
}

.qrcode-popup p {
  margin: 0 0 10px 0;
  color: #333;
  font-weight: 500;
}

.qrcode-placeholder {
  width: 150px;
  height: 150px;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  border-radius: 5px;
}

.qrcode-img {
  width: 147px;
  height: 147px;
}
</style>
